import React, { Component } from 'react'
import ProgressiveImage from 'react-progressive-image'
import './progressiveImage.css'

export default class ProgressiveImageWrap extends Component {
  render() {
    const { overlaySrc, src, alt, className, currentImage } = this.props
    return (
      <div style={{ position: 'relative' }}>
        <ProgressiveImage src={src} placeholder={overlaySrc}>
          {(src, loading) => (
            <img
              src={src}
              className={
                className +
                ' twisted-progressive-image ' +
                (loading ? 'loading' : 'loaded') +
                (currentImage > 1 ? ' blur-last-image' : '')
              }
              alt={alt}
              // onError={(e) => e.target?.offsetParent?.offsetParent.remove()} onError is optional
            />
          )}
        </ProgressiveImage>
        {currentImage > 1 &&
          <div className='search-card-last-image'>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              href={src}
              size="medium"
              fullwidth
              className="has-text-weight-bold button default-font"
            >
              See More
            </div>
          </div>
        }
      </div>
    )
  }
}
